import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  toolbar: {
    background: COLORS.white,
    borderBottom: `1px solid ${COLORS.border}`,
    padding: `12px ${SPACING.sectionGap}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACING.detailGap,
  },
  backButton: {
    cursor: 'pointer',
    fontSize: 14,
    color: COLORS.primary,
    fontWeight: 600,
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
  },
  toolbarActions: {
    display: 'flex',
    gap: 12,
  },
  scrollArea: {
    flex: 1,
    overflow: 'auto',
    padding: SPACING.sectionGap,
  },
  editorContainer: {
    maxWidth: 800,
    margin: '0 auto',
  },
  metaCard: {
    background: COLORS.white,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 6,
    padding: `${SPACING.cardPadding}px ${SPACING.cardPaddingHorizontal}px`,
    marginBottom: SPACING.formGroupGap,
  },
  metaGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: SPACING.formRowGap,
  },
  metaStats: {
    display: 'flex',
    gap: SPACING.detailGap,
    fontSize: 12,
    color: COLORS.muted,
    marginTop: SPACING.detailGap,
  },
  emptyState: {
    padding: 20,
    textAlign: 'center',
    color: COLORS.muted,
    fontSize: 13,
    background: COLORS.white,
    borderRadius: 6,
    border: `1px dashed ${COLORS.border}`,
    marginBottom: SPACING.cardMarginBottom,
  },
  accordionCard: {
    background: COLORS.white,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 10,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    marginBottom: SPACING.cardMarginBottom,
    overflow: 'hidden',
  },
  accordionHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: `${SPACING.cardPadding + 4}px ${SPACING.cardPaddingHorizontal}px`,
    gap: 12,
    cursor: 'pointer',
    width: '100%',
    border: 'none',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  accordionHeaderOpen: {
    background: '#fafcfd',
  },
  accordionHeaderClosed: {
    background: COLORS.white,
  },
  accordionBody: {
    padding: `${SPACING.cardPadding}px ${SPACING.cardPaddingHorizontal}px`,
    borderTop: `1px solid ${COLORS.border}`,
    background: '#fafcfd',
  },
  expandCollapseLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 11,
    fontWeight: 500,
    color: COLORS.primary,
    padding: '4px 10px',
    borderRadius: 6,
    background: COLORS.primaryLight,
  },
  expandCollapseIcon: {
    fontSize: 18,
  },
  deleteButton: {
    fontSize: 11,
    color: COLORS.error,
    padding: '4px 8px',
    borderRadius: 6,
    background: COLORS.errorLt,
    cursor: 'pointer',
    flexShrink: 0,
    border: 'none',
    fontFamily: 'inherit',
  },
}));
